import {
  activeFlagColumnDefinition,
  emailColumnDefinition,
  firstNameColumnDefinition,
  lastNameColumnDefinition,
  ssoColumnDefinition,
} from '../columnDefinitions';

export default [
  emailColumnDefinition,
  firstNameColumnDefinition,
  lastNameColumnDefinition,
  ssoColumnDefinition,
  activeFlagColumnDefinition,
];
